import { connect } from 'react-redux';
import Assignment from '../../../views/Personnel/Letter/Assignment.letter.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Assignment);
